'use strict';

angular.module('pulse')
    .filter('metadataDisplay', function() {
        return function metadataDisplay(metadata){
            return metadata.replace('_', ' ');
        };
});
